

export default function TextAirbnb(){
    return(
        <p>
        Airbnb will send you members-only deals, inspiration, marketing emails,
        and push notifications. You can opt out of receiving these at any time
        in your account settings or directly from the marketing notification.
      </p>
    )
}